import React, { useEffect } from 'react';
import { SceneManager } from '../../visualization/scene/GalaxyScene';
import { SceneConfig } from '../../visualization/scene/SceneConfig';
import { useGalaxyScene } from '../hooks/useGalaxyScene';

export interface ThreeCanvasProps {
  onSceneReady?: (scene: SceneManager) => void;
  config?: Partial<SceneConfig>;
  className?: string;
  style?: React.CSSProperties;
}

export function ThreeCanvas({ 
  onSceneReady, 
  config, 
  className = '',
  style = {}
}: ThreeCanvasProps) {
  const { sceneRef, scene, isReady } = useGalaxyScene(config);
  
  useEffect(() => {
    if (isReady && scene && onSceneReady) {
      onSceneReady(scene);
    }
  }, [isReady, scene, onSceneReady]);
  
  const defaultStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    ...style,
  };
  
  return (
    <div 
      ref={sceneRef} 
      className={className}
      style={defaultStyle}
    />
  );
}